import { render, staticRenderFns } from "./posisi_pegawai.vue?vue&type=template&id=852493f6&"
import script from "./posisi_pegawai.vue?vue&type=script&lang=js&"
export * from "./posisi_pegawai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports